import './loader.css';

export default function Loader() {
    return (
        <div className="loader-overlay">
            <div id="page">
                <div id="container">
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="h3">loading</div>
                </div>
            </div>
        </div>
    );
}
